import LazyTooltip from "@/components/Common/LazyTooltip";
import {type PlacesType} from "@/components/Common/Tooltip";
import clsxm from "@/lib/clsxm";
import type {TInfluencerStatistics} from "@/store/types";
import {useId, type FC} from "react";
import {useTranslation} from "react-i18next";

const InfluencerStatisticsRow: FC<{
  stats: TInfluencerStatistics[];
  tooltipPlace?: PlacesType;
  className?: string;
  textClassName?: string;
  statsContainerClassName?: string;
}> = ({stats, className, textClassName, tooltipPlace = "left", statsContainerClassName}) => {
  const {t} = useTranslation("influencer_profile");
  const id = useId();

  return (
    <div className={clsxm("flex items-start justify-between", className)}>
      {stats.map((statInfo, index) => (
        <div
          className={clsxm("flex flex-col items-center gap-1", statsContainerClassName)}
          key={index}
          data-tip
          data-tooltip-id={`${statInfo.tooltipTextTranslation}-${id}`}>
          {statInfo.component}
          {(statInfo.text || statInfo.label || statInfo.tooltipTextTranslation) && (
            <div className="flex flex-col items-center gap-1">
              {statInfo.text && (
                <span className={clsxm("text-neutral-black text-sm leading-4 font-semibold", textClassName)}>
                  {statInfo.text}
                </span>
              )}
              {statInfo.label && (
                <span className="text-neutral-grey-dark text-2xs leading-4">
                  {t(statInfo.label as "engagement_rate")}
                </span>
              )}
              {statInfo.tooltipTextTranslation && (
                <LazyTooltip
                  className="z-50"
                  id={`${statInfo.tooltipTextTranslation}-${id}`}
                  place={tooltipPlace}
                  variant="dark">
                  {t(statInfo.tooltipTextTranslation as "engagement_rate", {param: statInfo.textParam})}
                </LazyTooltip>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default InfluencerStatisticsRow;
